import { InfoPlayerIcon } from "@roman/shared/components/Icons";
import { useNavigate } from "react-router-dom";

export const MatchName = ({
  homeName,
  awayName,
  roundId,
}: {
  homeName: string;
  awayName: string;
  roundId: string;
}) => {
  const matchName = `${homeName} vs ${awayName}`;
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="w-full flex justify-center items-center py-2.5 bg-blue relative px-5 gap-2"
      onClick={() => navigate(`/rounds/${roundId}`)}
    >
      <div className="font-bold text-xs text-primary flex space-x-1 text-center">{matchName}</div>
      <InfoPlayerIcon className="[&_circle]:fill-white" />
    </button>
  );
};
